import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: null,
};

const gatewaySlice = createSlice({
  name: "gateway",
  initialState,
  reducers: {
    // create
    createGatewayStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    createGatewaySuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    createGatewayFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetCreateGatewayState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // update
    updateGatewayStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    updateGatewaySuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    updateGatewayFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetUpdateGatewayState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // delete
    deleteGatewayStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    deleteGatewaySuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    deleteGatewayFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetDeleteGatewayState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  createGatewayStart,
  createGatewaySuccess,
  createGatewayFailure,
  resetCreateGatewayState,
  updateGatewayStart,
  updateGatewaySuccess,
  updateGatewayFailure,
  resetUpdateGatewayState,
  deleteGatewayStart,
  deleteGatewaySuccess,
  deleteGatewayFailure,
  resetDeleteGatewayState,
} = gatewaySlice.actions;

export default gatewaySlice.reducer;
